<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <homeset-ads-edit v-if="editItem" v-bind="editItem" @cancel="editItem=null" @submit="onSubmit"></homeset-ads-edit>
      <b-card v-else header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">首頁輪播廣告列表</span>
          </div>
          <b-button variant="light" class="border float-right" @click="setEdit({})">新增廣告</b-button>
        </template>
        <b-button :disabled="!selectedArray.length" variant="danger" size="sm" @click="onClickDelete">刪除輪播廣告</b-button>
        <b-table
          id="ads-table"
          bordered
          show-empty
          empty-text="尚未新增輪播廣告"
          hover
          :items="items"
          :fields="fields"
          :busy="isBusy"
          responsive="md"
          class="mt-2"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(seq)="data">
            {{ data.index + 1}}
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox
              :id="`checkbox-${data.item.id}`"
              v-model="selectedArray"
              :value="data.item.id"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(img)="data">
            <b-img-lazy width="320" :src="data.value" blank-width="320" blank-height="100"></b-img-lazy>
          </template>
          <template v-slot:cell(unlimited)="data">
            <span v-if="data.value" class="text-danger">是</span>
            <span v-else class="text-success">否</span>
          </template>
          <template v-slot:cell(ops)="data">
            <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover title="向上移動" :disabled="data.index===0" @click.prevent="setItemSort(data.index, -1)">
              <font-awesome-icon icon="caret-square-up"></font-awesome-icon>
            </b-button>
            <b-button size="sm" variant="outline-secondary" class="mr-3 ml-3" @click.prevent="setEdit(data.item)">編輯</b-button>
            <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover title="向下移動" :disabled="data.index===items.length-1" @click.prevent="setItemSort(data.index, 1)">
              <font-awesome-icon icon="caret-square-down"></font-awesome-icon>
            </b-button>
          </template>
        </b-table>
        <!--b-pagination
          v-model="currentPage"
          :total-rows="rows"
          per-page="20"
          aria-controls="ads-table"
          class="float-right"
        ></b-pagination-->
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCaretSquareUp,
  faCaretSquareDown
} from '@fortawesome/free-solid-svg-icons'
library.add(faCaretSquareUp, faCaretSquareDown)
export default {
  name: 'homeset-ads',
  components: {
    HomesetAdsEdit: () => import('./HomesetAdsEdit.vue')
  },
  data () {
    return {
      currentPage: 1,
      rows: 0,
      items: [],
      isBusy: false,
      selectedArray: [],
      editItem: null
    }
  },
  computed: {
    fields () {
      return [
        { key: 'seq', label: '#', tdClass: 'text-center' },
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'name', label: '廣告名稱', tdClass: 'text-center' },
        { key: 'img', label: '輪播圖片', tdClass: 'text-center' },
        { key: 'start', label: '輪播開始時間', tdClass: 'text-center' },
        { key: 'end', label: '輪播結束時間', tdClass: 'text-center' },
        { key: 'unlimited', label: '永不下架', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    isParticalSelected () {
      return this.items.length !== 0 && this.selectedArray.length !== 0 && this.selectedArray.length !== this.items.length
    }
  },
  methods: {
    async fetch () {
      if (this.isBusy) return
      this.isBusy = true
      try {
        const { data } = await this.$api.getAds()
        data.sort((a, b) => a.sort - b.sort)
        data.forEach(item => {
          let unlimited = item.unlimited = !item.end
          item.img = this.$api.adsImageLink(item.id)
          item.start = moment(item.start).format('YYYY/MM/DD')
          item.end = unlimited ? '' : moment(item.end).format('YYYY/MM/DD')
        })
        this.items = data
      } catch (err) {
        console.log(err)
      } finally {
        this.isBusy = false
      }
      this.editItem = null
    },
    setEdit (item) {
      const formatStr = 'YYYY/MM/DD'
      let { id = null, name = '', start = null, end = null, link = '' } = item
      start = moment(start, formatStr).format('YYYY-MM-DD')
      end = moment(end, formatStr).format('YYYY-MM-DD')
      this.editItem = { id, name, start, end, link }
    },
    async onSubmit () {
      this.fetch()
    },
    async onClickDelete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.delAds(id))
      try {
        await Promise.all(wait)
        this.$bvToast.toast('資料已被刪除。', {
          variant: 'success',
          title: '操作成功'
        })
        this.isBusy = false
        await this.fetch()
        this.selectedArray = []
      } catch (err) {
        this.$bvToast.toast('連線失敗，資料刪除未成功。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    },
    async setItemSort (idx, move) {
      const find = this.items[idx]
      if (!find) return
      const array = this.items.filter(item => item !== find)
      let next = idx + move
      if (next <= 0) {
        array.unshif(find)
      } else if (next >= this.items.length) {
        array.push(find)
      } else {
        array.splice(next, 0, find)
      }
      array.forEach((item, idx) => {
        item.sort = idx
      })
      this.items = array
      const seq = array.map(item => item.id)
      try {
        await this.$api.putAdsSeq({ seq })
        this.$bvToast.toast('排序已儲存至資料庫', {
          title: '操作成功',
          variant: 'info'
        })
      } catch (err) {
        console.log(err)
      }
    } 
  },
  mounted () {
    this.fetch()
  }
}
</script>
